export const shouldPreventBlurOnEmojiTap = ({ isWeb, isMobile }) =>
  !!isWeb && !!isMobile;

export const shouldRefocusAfterEmojiInteraction = ({ isWeb, isMobile }) =>
  !(!!isWeb && !!isMobile);

export const shouldRefocusAfterEmojiSelect = ({
  isWeb,
  isMobile,
  wasSoftKeyboardOpen = true,
}) => {
  if (!(!!isWeb && !!isMobile)) return true;
  return !!wasSoftKeyboardOpen;
};

export const shouldRefocusAfterEmojiToggle = ({
  isWeb,
  isMobile,
  wasSoftKeyboardOpen = true,
}) => {
  if (!(!!isWeb && !!isMobile)) return true;
  return !!wasSoftKeyboardOpen;
};
